import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const AiPromptManagerAndroid: React.FC = () => (
  <SEOLandingPage
    title="AI Prompt Manager for Android — Save, Organize & Reuse Prompts | Cosmovex"
    metaDescription="PromptCrate is a free AI prompt manager for Android. Save your best ChatGPT, Claude and Gemini prompts, organize them with tags and folders, fill in variables, and copy a ready-to-paste prompt in seconds."
    ogTitle="AI Prompt Manager for Android — Your Prompt Library in Your Pocket"
    h1="AI Prompt Manager for Android"
    intro="Stop retyping your best prompts. PromptCrate keeps every prompt you've ever perfected — organized, searchable, and one tap from your clipboard. Fill in variables, copy, and paste into any AI app."
    paragraphs={[
      "If you use AI tools daily, your prompts are real work product. The detailed instruction that finally made the model write in your voice, the code-review checklist, the email rewriter with just the right tone — losing them in chat history means rebuilding them from scratch. PromptCrate gives prompts a permanent home on your phone.",
      "Organization that scales with your library. Group prompts into folders, tag them by tool or task, mark favorites, and find anything instantly with full-text search. A library of 50+ ready-made templates covers writing, coding, marketing, studying and more, so the crate is useful from the first minute.",
      "Variables make prompts reusable. Write a prompt once with placeholders — like the topic, the audience, or the programming language — and PromptCrate asks you to fill in the blanks each time, then copies the assembled prompt to your clipboard. Paste it into ChatGPT, Claude, Gemini, or any AI app you use. No more hunting through old conversations for the version that worked.",
      "Everything is stored on your device and works offline — your prompt library is yours, with no account required. The app is free to download, with a clean dark interface designed for quickly grabbing the right prompt mid-conversation.",
    ]}
    features={[
      "Save unlimited prompts with folders, tags and favorites",
      "50+ ready-made prompt templates to start from",
      "Variables — fill in the blanks and copy a finished prompt",
      "Full-text search across your whole library",
      "One-tap copy, paste into ChatGPT, Claude, Gemini or any AI app",
      "Works offline — your library lives on your device",
      "No account, no sign-up, free to download",
      "Clean dark interface built for speed",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.promptcrate"
    icon="/images/play/promptcrate.png"
    appName="PromptCrate: AI Prompt Manager"
    accentColor="#A8720E"
    canonicalPath="/ai-prompt-manager-android"
  />
);

export default AiPromptManagerAndroid;
